export default "__VITE_ASSET__DM7QEecs__"